import { Component, HostListener } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { CloudinaryService } from '../services/cloudinary.service';
import { SeoService } from '../services/seo.service';
import { MenuStateService } from '../services/menu-state.service';
import { filter, first } from 'rxjs';
import { DataService } from '../services/data.service';
import { EcommerceService } from '../services/ecommerce.service';

@Component({
  selector: 'app-nav-header',
  standalone: false,
  templateUrl: './nav-header.component.html',
  styleUrl: './nav-header.component.css'
})
export class NavHeaderComponent {
isScrolled = false;
  active:any;
  submenu: string | null = null;
  menus: { [key: string]: boolean } = {
    motos: false,
    lineafuerza: false,
    repuestos: false,
    servicios: false,
    novedades: false,
    nosotros: false,
    sucursales: false,
    contactanos: false,
    user: false
  };

  /*imágenes*/
  logo:any;
  imgexternallink:any;
  imgexternallinkblack:any;
  menuicontop:any = 'https://res.cloudinary.com/toyosa-sa/image/upload/v1733317324/production/toyota-bolivia/web/assets/icons/header/flecha_abierto.svg';
  menuicondown:any = 'https://res.cloudinary.com/toyosa-sa/image/upload/v1733317323/production/toyota-bolivia/web/assets/icons/header/flecha_cerrado.svg';
  imguser:any = 'https://res.cloudinary.com/toyosa-sa/image/upload/v1738783645/production/toyota-bolivia/web/assets/icons/header/user.png';
  imguserlogin:any = 'https://res.cloudinary.com/toyosa-sa/image/upload/v1742311007/production/toyota-bolivia/web/assets/icons/header/user-login.png';
  // Íconos personalizados para cada menú
  menuIcons: { [key: string]: { abierto: string; cerrado: string } } = {
    motos: { abierto: this.menuicontop, cerrado: this.menuicondown },
    lineafuerza: { abierto: this.menuicontop, cerrado: this.menuicondown },
    repuestos: { abierto: this.menuicontop, cerrado: this.menuicondown },
    servicios: { abierto: this.menuicontop, cerrado: this.menuicondown },
    novedades: { abierto: this.menuicontop, cerrado: this.menuicondown },
    nosotros: { abierto: this.menuicontop, cerrado: this.menuicondown },
    sucursales: { abierto: this.menuicontop, cerrado: this.menuicondown },
    contactanos: { abierto: this.menuicontop, cerrado: this.menuicondown },
    user: { abierto: this.menuicontop, cerrado: this.menuicondown },
  };
  menuExternalOpen = false;
  /* info del usuario*/
  public userData: any;
  public userJson:any;
  nombreUsuario:string="";
  cantidadCarrito:any;

  constructor(private router: Router, private cloudinaryService: CloudinaryService, private seoService: SeoService, private menuStateService: MenuStateService , private eCommerceService: EcommerceService) {
      //this.obtenerVehiculos();
      this.active = null;
      this.menuStateService.menuState$.subscribe((state) => {
      this.menuExternalOpen = state;
        if (this.menuExternalOpen) {
          
        }else {
          this.cerrarTodo();
        }
      });
      this.loadImage();

      
  }
  loadImage() {
    this.logo = this.cloudinaryService.getImageUrl('https://res.cloudinary.com/toyosa-sa/image/upload/v1750857028/production/yamaha/web/assets/mdbrdgarpdu0dwt0skug.svg', {
      width: 122, height: 42,
      fetch_format: 'auto', quality: 'auto'
    });
    this.imgexternallink = this.cloudinaryService.getImageUrl('https://res.cloudinary.com/toyosa-sa/image/upload/v1733317332/production/toyota-bolivia/web/assets/icons/header/pag_ext_negro-13.svg', {
      width: 13, height: 13,
      fetch_format: 'auto', quality: 'auto'
    });
    this.imgexternallinkblack = this.cloudinaryService.getImageUrl('https://res.cloudinary.com/toyosa-sa/image/upload/v1721914261/production/toyota-bolivia/web/assets/icons/external-link-black.svg', {
      width: 14, height: 14,
      fetch_format: 'auto',
      quality: 'auto'
    });
  }

  ngOnInit(): void {
    this.verificandoUsuario();
    this.router.events.pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.verificandoUsuario();
    });
    this.seoService.createLinkForCanonicalURL();
  }

  verificandoUsuario() {
    localStorage.removeItem("toyocarrito");
    this.userData = localStorage.getItem('userPlataformaTY');
    this.userJson = JSON.parse(this.userData);

    if(this.userJson != null){
        this.nombreUsuario = "Hola, "+(this.userJson['nombre'].split(' ')[0]);
        this.eCommerceService.verCarrito().pipe(first()).subscribe(
          data => {
            if(data.detalle_productos) {
              if(data.detalle_productos.length > 0) {
                localStorage.setItem('toyocarrito', JSON.stringify(data));
                this.cantidadCarrito = data.detalle_productos.length;
                //this.sucursalCarrito = data.detalle_productos[0].nombre_sucursal;
              } else {
              }
            }
            
          }, error => console.log(error)
        );
    } else {
      this.nombreUsuario = "Toyosa";
    }
  }
  
  abrirSubMenu(nombre: string): void {
    Object.keys(this.menus).forEach(key => {
      this.menus[key] = key === nombre ? !this.menus[key] : false;
    });
  }

  cerrarSubMenu(menu: string): void {
    this.menus[menu] = false;
  }

  cerrarTodo():void {
    this.menus = {
      motos: false,
      lineafuerza: false,
      repuestos: false,
      servicios: false,
      novedades: false,
      nosotros: false,
      sucursales: false,
      contactanos: false,
      user: false,
    };
  }

  isMenuOpen(menu: string): boolean {
    return this.menus[menu];
  }

  getMenuIcon(menu: string): string {
    return this.isMenuOpen(menu) ? this.menuIcons[menu].abierto : this.menuIcons[menu].cerrado;
  }
}
